import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { bonusValueRows, bonuses } from '../data/bonuses';
export function BonusSection() {
  return <section className="py-24 px-4 bg-carbon border-y border-carbon-line" data-id="element-18" data-mp="22f3f5ida9lp5">
      <div className="max-w-5xl mx-auto" data-id="element-19" data-mp="1ydru7q5ctona">
        <div className="text-center mb-16" data-id="element-20" data-mp="1ybxaug9qe4lb">
          <p className="text-gold font-bold tracking-widest uppercase mb-2" data-id="element-21" data-mp="1anxijbwru64m">
            Included at no extra cost
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-white" data-id="element-22" data-mp="15qnqrplwtidm">
            🎁 <span className="text-gold" data-id="element-23" data-mp="1jhsqsst6wcoh">5 Strategic Bonuses</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-24" data-mp="1epsoitpnd7oq">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05,
          duration: 0.3
        }} className="bg-carbon-graphite border border-gold/25 rounded-2xl p-8 relative" data-id="element-25" data-mp="qzesks3xyoov" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-gold text-carbon px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm" data-id="element-26" data-mp="2ji64g49kedln">
                BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 border border-gold rounded-full flex items-center justify-center text-gold mb-6" data-id="element-27" data-mp="2oitt4jabmicp">
                <GiftIcon size={22} data-id="element-28" data-mp="1vrs9a4vonymu" />
              </div>
              <h3 className="text-xl font-serif font-bold mb-2 pr-16 text-white" data-id="element-29" data-mp="1vsk3pcdjnqbj">{bonus.title}</h3>
              <p className="text-white/80 text-sm italic mb-4" data-id="element-30" data-mp="20q3m8oh9yp9a">{bonus.tagline}</p>
              <div className="inline-block bg-carbon border border-carbon-line px-3 py-1 rounded mb-4" data-id="element-31" data-mp="25s2p7x93rk5p">
                <span className="text-ash text-sm" data-id="element-32" data-mp="3c621ja31q7iy">
                  Real value: <span className="line-through" data-id="element-33" data-mp="3h4vbwtn1diew">${bonus.value}</span>
                </span>
                <span className="text-gold font-bold ml-2" data-id="element-34" data-mp="1h2vrish8hl14">→ FREE</span>
              </div>
              <div className="space-y-4 mb-6" data-id="element-35" data-mp="1c4kgwfj476hu">
                {bonus.paragraphs.map(paragraph => <p key={paragraph} className="text-mist text-sm leading-relaxed" data-id="element-36" data-mp="1q4lixyb48jyw">
                    {paragraph}
                  </p>)}
              </div>
              <p className="text-white text-sm italic font-medium border-t border-gold/25 pt-4" data-id="element-37" data-mp="ycxahmvgkhlc">
                {bonus.benefit}
              </p>
            </motion.article>)}
        </div>

        <div className="bg-carbon-graphite border border-gold rounded-2xl p-6 md:p-8 max-w-2xl mx-auto" data-id="element-38" data-mp="1757l35a9mp34">
          <h3 className="text-2xl font-serif font-bold text-white text-center mb-4" data-id="element-39" data-mp="12er97pm3fbiv">
            Total value of all <span className="text-gold" data-id="element-40" data-mp="eooknjhe0np0">5 bonuses</span>
          </h3>
          <p className="text-xs text-smoke text-center mb-3 md:hidden" data-id="element-41" data-mp="emtw7v6wqdg6">← Scroll to see full table →</p>
          <div className="overflow-x-auto" data-id="element-42" data-mp="aligchdu56l6">
            <table className="w-full text-sm min-w-[420px]" data-id="element-43" data-mp="j4mzy2av0hc">
              <thead data-id="element-44" data-mp="5a4lv8uzbsmh">
                <tr className="border-b border-gold/50" data-id="element-45" data-mp="5amsmzf9pp8n">
                  <th scope="col" className="text-left font-bold px-4 py-3 text-gold" data-id="element-46" data-mp="5c7kuie40w3c">Bonus</th>
                  <th scope="col" className="text-right font-bold px-4 py-3 text-gold" data-id="element-47" data-mp="3moi3jaytuv40">Value</th>
                </tr>
              </thead>
              <tbody data-id="element-48" data-mp="ja5p2uypvc54">
                {bonusValueRows.map(row => <tr key={row.label} className="border-b border-carbon-line" data-id="element-49" data-mp="j81lke4qcf5d">
                    <td className="px-4 py-3 text-mist" data-id="element-50" data-mp="o87gq4a7kjs7">{row.label}</td>
                    <td className="px-4 py-3 text-right text-ash line-through" data-id="element-51" data-mp="9aokkgv7b4aq">{row.value}</td>
                  </tr>)}
                <tr className="border-b border-carbon-line" data-id="element-52" data-mp="ecw1lkuw1ajx">
                  <td className="px-4 py-3 font-bold text-white" data-id="element-53" data-mp="2u0vzy2plnqh5">TOTAL</td>
                  <td className="px-4 py-3 text-right font-bold text-ash line-through" data-id="element-54" data-mp="2z1jpsl23e19s">$54</td>
                </tr>
                <tr data-id="element-55" data-mp="3f8ercs5tiks3">
                  <td className="px-4 py-4 font-bold text-white" data-id="element-56" data-mp="3f9pwoweww0lb">Your price today</td>
                  <td className="px-4 py-4 text-right font-bold text-gold text-lg" data-id="element-57" data-mp="3agex9gcfim3f">🎁 FREE</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className="text-sm text-smoke text-center mt-4" data-id="element-58" data-mp="30jikuzjetftl">
            Only included in this offer. The launch price ends soon. After this,
            the price goes up and it does not come back down.
          </p>
        </div>

        <CountdownTimer data-id="element-59" data-mp="3t9957qbmxdy5" />
      </div>
    </section>;
}